import React from 'react';

/**
 * Visas när uppföljningsmötet redan är bokat
 * Scenario B: MEETING_BOOKED
 */
const BookedMeetingDisplay = ({
  bookedSlot,
  userRole,
  onShowEstimatCustomerView,
  onEditMeeting,
  onCancelMeeting,
  isEditing = false,
  isCancelling = false,
  onApproveForCustomer,
  onBookHomeVisit,
  approveLoading = false,
  isApproved = false,
}) => {
  const isLoading = isEditing || isCancelling;

  return (
    <div>
      <ul className="space-y-2 text-sm text-gray-700 mb-4">
        <li className="flex items-center justify-between gap-4 bg-gray-50 border border-gray-200 rounded px-3 py-2">
          <span className="text-gray-900">{bookedSlot}</span>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="px-2.5 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap flex items-center gap-1 bg-green-700 text-white opacity-80 cursor-not-allowed"
              title="Mötet är bokat"
              disabled
            >
              <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Bokad
            </button>
            {/* Ändra-knapp - endast för byggkonsulter */}
            {userRole === 'byggkonsult' && onEditMeeting && (
              <button
                type="button"
                className="px-2.5 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap flex items-center gap-1 text-gray-600 bg-white border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50"
                onClick={onEditMeeting}
                disabled={isLoading}
                title="Ändra mötestid"
              >
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                {isEditing ? 'Ändrar...' : 'Ändra'}
              </button>
            )}
          </div>
        </li>
      </ul>

      {/* "Godkänn åt kund" låg tidigare här, men var svår att hitta nere i
          uppföljningssektionen. Den ligger nu i knappraden högst upp i
          estimatet, bredvid "Visa kundvy". */}

      {/* Hembesöks-knapp för byggkonsulter efter godkännande */}
      {userRole === 'byggkonsult' && onBookHomeVisit && isApproved && (
        <div className="mt-4 flex items-center gap-2">
          <button
            type="button"
            className="px-2.5 py-1.5 sm:px-3 text-sm font-medium rounded-lg whitespace-nowrap flex items-center gap-1.5 bg-leadme-pink text-white hover:bg-leadme-pink-dark transition-colors"
            onClick={onBookHomeVisit}
            title="Boka hembesök, föreslå tider eller hoppa över"
          >
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Boka hembesök
          </button>
        </div>
      )}
    </div>
  );
};

export default BookedMeetingDisplay;
